import { render, staticRenderFns } from "./EdenInformationCard.vue?vue&type=template&id=2aced2ad&scoped=true"
import script from "./EdenInformationCard.vue?vue&type=script&lang=js"
export * from "./EdenInformationCard.vue?vue&type=script&lang=js"
import style0 from "./EdenInformationCard.vue?vue&type=style&index=0&id=2aced2ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aced2ad",
  null
  
)

export default component.exports